@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-791_252_228)
internal val Res.drawable.polished_diorite_slab: DrawableResource by lazy {
      DrawableResource("drawable:polished_diorite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_diorite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_358_116_573)
internal val Res.drawable.polished_diorite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:polished_diorite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_diorite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_648_134_249)
internal val Res.drawable.polished_granite: DrawableResource by lazy {
      DrawableResource("drawable:polished_granite", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_granite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_872_814_515)
internal val Res.drawable.polished_granite_slab: DrawableResource by lazy {
      DrawableResource("drawable:polished_granite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_granite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(697_059_484)
internal val Res.drawable.polished_granite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:polished_granite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_granite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-34_040_474)
internal val Res.drawable.popped_chorus_fruit: DrawableResource by lazy {
      DrawableResource("drawable:popped_chorus_fruit", setOf(
        ResourceItem(setOf(), "${MD}drawable/popped_chorus_fruit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-624_735_387)
internal val Res.drawable.poppy: DrawableResource by lazy {
      DrawableResource("drawable:poppy", setOf(
        ResourceItem(setOf(), "${MD}drawable/poppy.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(829_122_707)
internal val Res.drawable.porkchop: DrawableResource by lazy {
      DrawableResource("drawable:porkchop", setOf(
        ResourceItem(setOf(), "${MD}drawable/porkchop.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(45_599_538)
internal val Res.drawable.potato: DrawableResource by lazy {
      DrawableResource("drawable:potato", setOf(
        ResourceItem(setOf(), "${MD}drawable/potato.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_155_788_963)
internal val Res.drawable.potion: DrawableResource by lazy {
      DrawableResource("drawable:potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(342_521_463)
internal val Res.drawable.powered_rail: DrawableResource by lazy {
      DrawableResource("drawable:powered_rail", setOf(
        ResourceItem(setOf(), "${MD}drawable/powered_rail.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_631_449)
internal val Res.drawable.prismarine: DrawableResource by lazy {
      DrawableResource("drawable:prismarine", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_345_637_303)
internal val Res.drawable.prismarine_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_029_837_816)
internal val Res.drawable.prismarine_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_022_296_862)
internal val Res.drawable.prismarine_bricks: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-527_649_879)
internal val Res.drawable.prismarine_crystals: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_crystals", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_crystals.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_386_455_924)
internal val Res.drawable.prismarine_shard: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_shard", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_shard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_790_288_089)
internal val Res.drawable.prismarine_slab: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_906_881_007)
internal val Res.drawable.prismarine_stairs: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-772_305_851)
internal val Res.drawable.prismarine_wall: DrawableResource by lazy {
      DrawableResource("drawable:prismarine_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/prismarine_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(737_346_840)
internal val Res.drawable.pufferfish: DrawableResource by lazy {
      DrawableResource("drawable:pufferfish", setOf(
        ResourceItem(setOf(), "${MD}drawable/pufferfish.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_992_042_924)
internal val Res.drawable.pufferfish_bucket: DrawableResource by lazy {
      DrawableResource("drawable:pufferfish_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/pufferfish_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_029_671_215)
internal val Res.drawable.pufferfish_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:pufferfish_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/pufferfish_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(771_080_452)
internal val Res.drawable.pumpkin: DrawableResource by lazy {
      DrawableResource("drawable:pumpkin", setOf(
        ResourceItem(setOf(), "${MD}drawable/pumpkin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_837_136_271)
internal val Res.drawable.pumpkin_pie: DrawableResource by lazy {
      DrawableResource("drawable:pumpkin_pie", setOf(
        ResourceItem(setOf(), "${MD}drawable/pumpkin_pie.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-125_340_623)
internal val Res.drawable.pumpkin_seeds: DrawableResource by lazy {
      DrawableResource("drawable:pumpkin_seeds", setOf(
        ResourceItem(setOf(), "${MD}drawable/pumpkin_seeds.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_411_025_975)
internal val Res.drawable.purple_banner: DrawableResource by lazy {
      DrawableResource("drawable:purple_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-108_700_027)
internal val Res.drawable.purple_bed: DrawableResource by lazy {
      DrawableResource("drawable:purple_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(421_163_954)
internal val Res.drawable.purple_carpet: DrawableResource by lazy {
      DrawableResource("drawable:purple_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(790_787_558)
internal val Res.drawable.purple_concrete: DrawableResource by lazy {
      DrawableResource("drawable:purple_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_391_033_866)
internal val Res.drawable.purple_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:purple_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_868_681_401)
internal val Res.drawable.purple_dye: DrawableResource by lazy {
      DrawableResource("drawable:purple_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-730_538_163)
internal val Res.drawable.purple_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:purple_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-19_407_235)
internal val Res.drawable.purple_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:purple_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_170_275_628)
internal val Res.drawable.purple_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:purple_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_917_428_217)
internal val Res.drawable.purple_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:purple_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_087_783_579)
internal val Res.drawable.purple_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:purple_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_094_129_900)
internal val Res.drawable.purple_wool: DrawableResource by lazy {
      DrawableResource("drawable:purple_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/purple_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_093_160_333)
internal val Res.drawable.purpur_block: DrawableResource by lazy {
      DrawableResource("drawable:purpur_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/purpur_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-316_196_047)
internal val Res.drawable.purpur_pillar: DrawableResource by lazy {
      DrawableResource("drawable:purpur_pillar", setOf(
        ResourceItem(setOf(), "${MD}drawable/purpur_pillar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(278_430_009)
internal val Res.drawable.purpur_slab: DrawableResource by lazy {
      DrawableResource("drawable:purpur_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/purpur_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-752_719_537)
internal val Res.drawable.purpur_stairs: DrawableResource by lazy {
      DrawableResource("drawable:purpur_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/purpur_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_831_307_961)
internal val Res.drawable.quartz: DrawableResource by lazy {
      DrawableResource("drawable:quartz", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_843_198_957)
internal val Res.drawable.quartz_block: DrawableResource by lazy {
      DrawableResource("drawable:quartz_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_833_296_547)
internal val Res.drawable.quartz_bricks: DrawableResource by lazy {
      DrawableResource("drawable:quartz_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(133_345_069)
internal val Res.drawable.quartz_pillar: DrawableResource by lazy {
      DrawableResource("drawable:quartz_pillar", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz_pillar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-891_462_499)
internal val Res.drawable.quartz_slab: DrawableResource by lazy {
      DrawableResource("drawable:quartz_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_407_021_030)
internal val Res.drawable.quartz_stairs: DrawableResource by lazy {
      DrawableResource("drawable:quartz_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/quartz_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_124_419_148)
internal val Res.drawable.rabbit: DrawableResource by lazy {
      DrawableResource("drawable:rabbit", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(502_834_230)
internal val Res.drawable.rabbit_foot: DrawableResource by lazy {
      DrawableResource("drawable:rabbit_foot", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit_foot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_249_209_487)
internal val Res.drawable.rabbit_hide: DrawableResource by lazy {
      DrawableResource("drawable:rabbit_hide", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit_hide.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_695_328_216)
internal val Res.drawable.rabbit_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:rabbit_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_421_005_227)
internal val Res.drawable.rabbit_stew: DrawableResource by lazy {
      DrawableResource("drawable:rabbit_stew", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit_stew.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(683_732_177)
internal val Res.drawable.rail: DrawableResource by lazy {
      DrawableResource("drawable:rail", setOf(
        ResourceItem(setOf(), "${MD}drawable/rail.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(832_500_948)
internal val Res.drawable.ravager_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:ravager_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/ravager_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-400_312_285)
internal val Res.drawable.red_banner: DrawableResource by lazy {
      DrawableResource("drawable:red_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(541_134_431)
internal val Res.drawable.red_bed: DrawableResource by lazy {
      DrawableResource("drawable:red_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(351_204_145)
internal val Res.drawable.red_carpet: DrawableResource by lazy {
      DrawableResource("drawable:red_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_663_932_208)
internal val Res.drawable.red_concrete: DrawableResource by lazy {
      DrawableResource("drawable:red_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_106_531_675)
internal val Res.drawable.red_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:red_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-265_991_177)
internal val Res.drawable.red_dye: DrawableResource by lazy {
      DrawableResource("drawable:red_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_400_359_094)
internal val Res.drawable.red_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:red_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_558_223_901)
internal val Res.drawable.red_mushroom: DrawableResource by lazy {
      DrawableResource("drawable:red_mushroom", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_mushroom.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(476_140_433)
internal val Res.drawable.red_mushroom_block: DrawableResource by lazy {
      DrawableResource("drawable:red_mushroom_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_mushroom_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(534_264_000)
internal val Res.drawable.red_nether_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:red_nether_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_nether_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(899_886_539)
internal val Res.drawable.red_nether_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:red_nether_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_nether_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(92_290_616)
internal val Res.drawable.red_nether_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:red_nether_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_nether_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_610_444_112)
internal val Res.drawable.red_nether_bricks: DrawableResource by lazy {
      DrawableResource("drawable:red_nether_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_nether_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-21_693_844)
internal val Res.drawable.red_sand: DrawableResource by lazy {
      DrawableResource("drawable:red_sand", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_sand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-463_383_092)
internal val Res.drawable.red_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:red_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-405_716_048)
internal val Res.drawable.red_sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:red_sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_255_035_910)
internal val Res.drawable.red_sandstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:red_sandstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_sandstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(761_701_096)
internal val Res.drawable.red_sandstone_wall: DrawableResource by lazy {
      DrawableResource("drawable:red_sandstone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_sandstone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-36_799_975)
internal val Res.drawable.red_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:red_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-642_278_212)
internal val Res.drawable.red_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:red_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-615_262_169)
internal val Res.drawable.red_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:red_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_738_535_680)
internal val Res.drawable.red_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:red_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-730_155_456)
internal val Res.drawable.red_tulip: DrawableResource by lazy {
      DrawableResource("drawable:red_tulip", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_tulip.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-412_659_658)
internal val Res.drawable.red_wool: DrawableResource by lazy {
      DrawableResource("drawable:red_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_716_926_984)
internal val Res.drawable.redstone: DrawableResource by lazy {
      DrawableResource("drawable:redstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/redstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(212_912_386)
internal val Res.drawable.redstone_block: DrawableResource by lazy {
      DrawableResource("drawable:redstone_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/redstone_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_042_961_488)
internal val Res.drawable.redstone_lamp: DrawableResource by lazy {
      DrawableResource("drawable:redstone_lamp", setOf(
        ResourceItem(setOf(), "${MD}drawable/redstone_lamp.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(854_927_589)
internal val Res.drawable.redstone_ore: DrawableResource by lazy {
      DrawableResource("drawable:redstone_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/redstone_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_715_903_486)
internal val Res.drawable.redstone_torch: DrawableResource by lazy {
      DrawableResource("drawable:redstone_torch", setOf(
        ResourceItem(setOf(), "${MD}drawable/redstone_torch.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_942_730_966)
internal val Res.drawable.repeater: DrawableResource by lazy {
      DrawableResource("drawable:repeater", setOf(
        ResourceItem(setOf(), "${MD}drawable/repeater.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_276_545_577)
internal val Res.drawable.repeating_command_block: DrawableResource by lazy {
      DrawableResource("drawable:repeating_command_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/repeating_command_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_986_541_533)
internal val Res.drawable.respawn_anchor: DrawableResource by lazy {
      DrawableResource("drawable:respawn_anchor", setOf(
        ResourceItem(setOf(), "${MD}drawable/respawn_anchor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(599_694_182)
internal val Res.drawable.rose_bush: DrawableResource by lazy {
      DrawableResource("drawable:rose_bush", setOf(
        ResourceItem(setOf(), "${MD}drawable/rose_bush.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(759_108_271)
internal val Res.drawable.rotten_flesh: DrawableResource by lazy {
      DrawableResource("drawable:rotten_flesh", setOf(
        ResourceItem(setOf(), "${MD}drawable/rotten_flesh.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(266_699_893)
internal val Res.drawable.saddle: DrawableResource by lazy {
      DrawableResource("drawable:saddle", setOf(
        ResourceItem(setOf(), "${MD}drawable/saddle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_364_883_095)
internal val Res.drawable.salmon: DrawableResource by lazy {
      DrawableResource("drawable:salmon", setOf(
        ResourceItem(setOf(), "${MD}drawable/salmon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_525_163_039)
internal val Res.drawable.salmon_bucket: DrawableResource by lazy {
      DrawableResource("drawable:salmon_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/salmon_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(637_546_603)
internal val Res.drawable.salmon_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:salmon_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/salmon_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-449_986_943)
internal val Res.drawable.sand: DrawableResource by lazy {
      DrawableResource("drawable:sand", setOf(
        ResourceItem(setOf(), "${MD}drawable/sand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(593_232_143)
internal val Res.drawable.sandstone: DrawableResource by lazy {
      DrawableResource("drawable:sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(364_215_377)
internal val Res.drawable.sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-734_411_259)
internal val Res.drawable.sandstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:sandstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/sandstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_935_031_432)
internal val Res.drawable.sandstone_wall: DrawableResource by lazy {
      DrawableResource("drawable:sandstone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/sandstone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-29_318_859)
internal val Res.drawable.scaffolding: DrawableResource by lazy {
      DrawableResource("drawable:scaffolding", setOf(
        ResourceItem(setOf(), "${MD}drawable/scaffolding.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(133_287_677)
internal val Res.drawable.scute: DrawableResource by lazy {
      DrawableResource("drawable:scute", setOf(
        ResourceItem(setOf(), "${MD}drawable/scute.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable7Resources(map: MutableMap<String, DrawableResource>) {
  map.put("polished_diorite_slab", Res.drawable.polished_diorite_slab)
  map.put("polished_diorite_stairs", Res.drawable.polished_diorite_stairs)
  map.put("polished_granite", Res.drawable.polished_granite)
  map.put("polished_granite_slab", Res.drawable.polished_granite_slab)
  map.put("polished_granite_stairs", Res.drawable.polished_granite_stairs)
  map.put("popped_chorus_fruit", Res.drawable.popped_chorus_fruit)
  map.put("poppy", Res.drawable.poppy)
  map.put("porkchop", Res.drawable.porkchop)
  map.put("potato", Res.drawable.potato)
  map.put("potion", Res.drawable.potion)
  map.put("powered_rail", Res.drawable.powered_rail)
  map.put("prismarine", Res.drawable.prismarine)
  map.put("prismarine_brick_slab", Res.drawable.prismarine_brick_slab)
  map.put("prismarine_brick_stairs", Res.drawable.prismarine_brick_stairs)
  map.put("prismarine_bricks", Res.drawable.prismarine_bricks)
  map.put("prismarine_crystals", Res.drawable.prismarine_crystals)
  map.put("prismarine_shard", Res.drawable.prismarine_shard)
  map.put("prismarine_slab", Res.drawable.prismarine_slab)
  map.put("prismarine_stairs", Res.drawable.prismarine_stairs)
  map.put("prismarine_wall", Res.drawable.prismarine_wall)
  map.put("pufferfish", Res.drawable.pufferfish)
  map.put("pufferfish_bucket", Res.drawable.pufferfish_bucket)
  map.put("pufferfish_spawn_egg", Res.drawable.pufferfish_spawn_egg)
  map.put("pumpkin", Res.drawable.pumpkin)
  map.put("pumpkin_pie", Res.drawable.pumpkin_pie)
  map.put("pumpkin_seeds", Res.drawable.pumpkin_seeds)
  map.put("purple_banner", Res.drawable.purple_banner)
  map.put("purple_bed", Res.drawable.purple_bed)
  map.put("purple_carpet", Res.drawable.purple_carpet)
  map.put("purple_concrete", Res.drawable.purple_concrete)
  map.put("purple_concrete_powder", Res.drawable.purple_concrete_powder)
  map.put("purple_dye", Res.drawable.purple_dye)
  map.put("purple_glazed_terracotta", Res.drawable.purple_glazed_terracotta)
  map.put("purple_shulker_box", Res.drawable.purple_shulker_box)
  map.put("purple_stained_glass", Res.drawable.purple_stained_glass)
  map.put("purple_stained_glass_pane", Res.drawable.purple_stained_glass_pane)
  map.put("purple_terracotta", Res.drawable.purple_terracotta)
  map.put("purple_wool", Res.drawable.purple_wool)
  map.put("purpur_block", Res.drawable.purpur_block)
  map.put("purpur_pillar", Res.drawable.purpur_pillar)
  map.put("purpur_slab", Res.drawable.purpur_slab)
  map.put("purpur_stairs", Res.drawable.purpur_stairs)
  map.put("quartz", Res.drawable.quartz)
  map.put("quartz_block", Res.drawable.quartz_block)
  map.put("quartz_bricks", Res.drawable.quartz_bricks)
  map.put("quartz_pillar", Res.drawable.quartz_pillar)
  map.put("quartz_slab", Res.drawable.quartz_slab)
  map.put("quartz_stairs", Res.drawable.quartz_stairs)
  map.put("rabbit", Res.drawable.rabbit)
  map.put("rabbit_foot", Res.drawable.rabbit_foot)
  map.put("rabbit_hide", Res.drawable.rabbit_hide)
  map.put("rabbit_spawn_egg", Res.drawable.rabbit_spawn_egg)
  map.put("rabbit_stew", Res.drawable.rabbit_stew)
  map.put("rail", Res.drawable.rail)
  map.put("ravager_spawn_egg", Res.drawable.ravager_spawn_egg)
  map.put("red_banner", Res.drawable.red_banner)
  map.put("red_bed", Res.drawable.red_bed)
  map.put("red_carpet", Res.drawable.red_carpet)
  map.put("red_concrete", Res.drawable.red_concrete)
  map.put("red_concrete_powder", Res.drawable.red_concrete_powder)
  map.put("red_dye", Res.drawable.red_dye)
  map.put("red_glazed_terracotta", Res.drawable.red_glazed_terracotta)
  map.put("red_mushroom", Res.drawable.red_mushroom)
  map.put("red_mushroom_block", Res.drawable.red_mushroom_block)
  map.put("red_nether_brick_slab", Res.drawable.red_nether_brick_slab)
  map.put("red_nether_brick_stairs", Res.drawable.red_nether_brick_stairs)
  map.put("red_nether_brick_wall", Res.drawable.red_nether_brick_wall)
  map.put("red_nether_bricks", Res.drawable.red_nether_bricks)
  map.put("red_sand", Res.drawable.red_sand)
  map.put("red_sandstone", Res.drawable.red_sandstone)
  map.put("red_sandstone_slab", Res.drawable.red_sandstone_slab)
  map.put("red_sandstone_stairs", Res.drawable.red_sandstone_stairs)
  map.put("red_sandstone_wall", Res.drawable.red_sandstone_wall)
  map.put("red_shulker_box", Res.drawable.red_shulker_box)
  map.put("red_stained_glass", Res.drawable.red_stained_glass)
  map.put("red_stained_glass_pane", Res.drawable.red_stained_glass_pane)
  map.put("red_terracotta", Res.drawable.red_terracotta)
  map.put("red_tulip", Res.drawable.red_tulip)
  map.put("red_wool", Res.drawable.red_wool)
  map.put("redstone", Res.drawable.redstone)
  map.put("redstone_block", Res.drawable.redstone_block)
  map.put("redstone_lamp", Res.drawable.redstone_lamp)
  map.put("redstone_ore", Res.drawable.redstone_ore)
  map.put("redstone_torch", Res.drawable.redstone_torch)
  map.put("repeater", Res.drawable.repeater)
  map.put("repeating_command_block", Res.drawable.repeating_command_block)
  map.put("respawn_anchor", Res.drawable.respawn_anchor)
  map.put("rose_bush", Res.drawable.rose_bush)
  map.put("rotten_flesh", Res.drawable.rotten_flesh)
  map.put("saddle", Res.drawable.saddle)
  map.put("salmon", Res.drawable.salmon)
  map.put("salmon_bucket", Res.drawable.salmon_bucket)
  map.put("salmon_spawn_egg", Res.drawable.salmon_spawn_egg)
  map.put("sand", Res.drawable.sand)
  map.put("sandstone", Res.drawable.sandstone)
  map.put("sandstone_slab", Res.drawable.sandstone_slab)
  map.put("sandstone_stairs", Res.drawable.sandstone_stairs)
  map.put("sandstone_wall", Res.drawable.sandstone_wall)
  map.put("scaffolding", Res.drawable.scaffolding)
  map.put("scute", Res.drawable.scute)
}
